
var stache = require('can/view/stache/stache');
module.exports = stache("<general-schedule {data}=\"events\"/>\r\n");